import { FormControlLabel } from '@mui/material';
import { Field, FieldAttributes, useFormikContext } from 'formik';
import { Checkbox } from 'formik-mui';
import React, { useCallback } from 'react';

type Props = FieldAttributes<any>;

export const FormikCheckbox: React.FC<Props> = ({
  name,
  label,
  sx,
  ...rest
}) => {
  const formik = useFormikContext();

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formik.handleChange(e);
      rest.onChange?.(e.target.checked);
    },
    [formik, rest],
  );

  return (
    <div>
      <FormControlLabel
        control={
          <Field
            component={Checkbox}
            type="checkbox"
            name={name}
            sx={{ paddingTop: 1, paddingBottom: 1 }}
            {...rest}
            {...(rest.onChange && { onChange: handleChange })}
          />
        }
        label={label}
        sx={sx}
      />
    </div>
  );
};
